/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React              from 'react';
import PropTypes          from 'prop-types';
import { StyledLogo }     from '../../atoms/StyledLogo';
import { StyledSiteName } from '../../atoms/StyledSiteName';
import { PricePaidData }  from '../../atoms/PricePaidData';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const Logo = ({ children }) => (
    <StyledLogo>
        {children}
        <StyledSiteName>
            <PricePaidData/>
        </StyledSiteName>
    </StyledLogo>
);

Logo.propTypes = {
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/molecules/Logo/index.js